var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quote && _vm.quote.text)?_c('section',{staticClass:"section section-quote"},[_c('div',{staticClass:"container container-small"},[_c('Blockquote',{attrs:{"visible":_vm.visible || _vm.mobile,"quote":_vm.quote}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }